import { React, useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Table, TableBody, TableCell, TableRow, Button, IconButton } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

const DetailsModal = ({ showDModal, onClose, selectedOrder, BackdropProps }) => {
    const [images, setImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [imageModalOpen, setImageModalOpen] = useState(false);

    useEffect(() => {
        if (!showDModal) {
            setImages([]);
            setImageModalOpen(false);
            setCurrentImageIndex(0);
        }
    }, [showDModal]);

    useEffect(() => {
        setImages([]);
        setCurrentImageIndex(0);
    }, [selectedOrder?.Order_No]);

    if (!showDModal) return null;

    const getStatusText = () => {
        switch (selectedOrder.o_status) {
            case "0":
                return "Unassigned";
            case "1":
                return "Assigned";
            case "2":
                return "Completed";
            case "3":
                return "Incomplete";
            case "4":
                return "On Way";
            default:
                return "";
        }
    };

    const handlePrint = () => {
        window.print();
    };

    return (
        <>
            <Dialog open={showDModal} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>
                    <Typography variant="h6" component="div" style={{ display: 'flex', alignItems: 'center' }}>
                        <strong>{selectedOrder && selectedOrder.Order_No}</strong>
                        <IconButton onClick={handlePrint} style={{ marginLeft: 'auto' }}>
                            <PrintIcon />
                        </IconButton>
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography variant="subtitle1" gutterBottom>
                        <strong>Status:</strong> {getStatusText()}
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Address Details
                    </Typography>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <strong>Deliver To:</strong> <br />
                                    {selectedOrder && selectedOrder.Rec_Name} <br />
                                    {selectedOrder && selectedOrder.Rec_Add} <br />
                                    {selectedOrder && selectedOrder.Cust_No} <br />
                                </TableCell>
                                <TableCell>
                                    <strong>Pickup From:</strong> <br />
                                    {selectedOrder && selectedOrder.Comp_Name} <br />
                                    {selectedOrder && selectedOrder.Comp_Add} <br />
                                    {selectedOrder && selectedOrder.Pick_Loc_No} <br />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    <Typography variant="h6" gutterBottom>
                        Order Details
                    </Typography>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell><strong>Driver Email</strong></TableCell>
                                <TableCell>{selectedOrder && selectedOrder.Driv_Email}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Order Amount (in Rs. )</strong></TableCell>
                                <TableCell>₹ {selectedOrder && selectedOrder.amount}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    <Typography variant="h6" gutterBottom>
                        Delivery Details
                    </Typography>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell><strong>Order Assigned Time</strong></TableCell>
                                <TableCell>{selectedOrder && selectedOrder.assign_time}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Order Pickup Time</strong></TableCell>
                                <TableCell>{selectedOrder && selectedOrder.Pick_Date_Actual + " " + selectedOrder.Pick_Time_Actual}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <strong>{selectedOrder && selectedOrder.o_status === '3' ? 'Failure Time' : 'Delivery Time'}</strong>
                                </TableCell>
                                <TableCell>{selectedOrder && selectedOrder.Pick_Date_Actual + " " + selectedOrder.Del_Time_Actual}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Requested Pickup Time</strong></TableCell>
                                <TableCell>{selectedOrder && selectedOrder.Pick_Date + " " + selectedOrder.Pick_Time}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Expected Delivery Time</strong></TableCell>
                                <TableCell>{selectedOrder && selectedOrder.Del_Date + " " + selectedOrder.Del_Time}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    {selectedOrder && selectedOrder.o_status === '2' && (
                        <>
                            <Typography variant="h6" gutterBottom>
                                Payment Details
                            </Typography>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell><strong>Total Amount</strong></TableCell>
                                        <TableCell>₹ {selectedOrder && selectedOrder.amount}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell><strong>Mode of Payment</strong></TableCell>
                                        <TableCell>{selectedOrder && (selectedOrder.mop || selectedOrder.mop2 || selectedOrder.mop3)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </>
                    )}

                    {selectedOrder && selectedOrder.o_status === '3' && (
                        <>
                            <Typography variant="h6" gutterBottom>
                                Cancellation Details
                            </Typography>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell><strong>Reason for Failure</strong></TableCell>
                                        <TableCell>{selectedOrder && selectedOrder.reason_failure}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} variant="contained"
                        sx={{
                            background: 'linear-gradient(45deg, #79c6e9 30%, #79c6e9 90%)', // Light green gradient
                            color: 'white',
                            '&:hover': {
                                background: 'linear-gradient(45deg, #79c6e9 30%, #79c6e9 90%)', // Inverted light green gradient on hover
                            }
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={imageModalOpen} onClose={() => setImageModalOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {selectedOrder?.o_status === '2' ? 'Proof of Delivery Images' : 'Proof of Failure Images'}
                </DialogTitle>
                <DialogContent>
                    {images.length > 0 ? (
                        <>
                            <img src={images[currentImageIndex]} alt="" style={{ maxWidth: '100%', maxHeight: '400px' }} />
                            <Typography>{currentImageIndex + 1} / {images.length}</Typography>
                            <Button disabled={currentImageIndex === 0} onClick={() => setCurrentImageIndex(prev => prev - 1)}>
                                &larr;
                            </Button>
                            <Button disabled={currentImageIndex === images.length - 1} onClick={() => setCurrentImageIndex(prev => prev + 1)}>
                                &rarr;
                            </Button>
                        </>
                    ) : (
                        <Typography>No images available.</Typography>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default DetailsModal;
